import { inject } from 'mobx-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

import { useLocalization } from '@shared-ui/localization-context';

import { CurrentHotelStore } from 'stores/current-hotel-store';

export const AVAILABILITY_HEADER_REF_NAME = 'availabilityHeader';

export const ListingsHeader: React.FC<{ RightComponent?: React.ReactNode; currentHotel?: CurrentHotelStore }> = inject('currentHotel')(
  ({ RightComponent, currentHotel }) => {
    const { formatText } = useLocalization();

    const { defaultedDates, offers } = currentHotel;
    const headerTitle = defaultedDates
      ? formatText('hotels.infosite.availabilityWizard.roomSelection.dateless.title')
      : offers?.listingsHeader?.text;

    if (!headerTitle) {
      return null;
    }

    const headerTitleClass = 'm-x-padding-zero l-x-padding-zero';
    const dataStid = 'availability-wizard-header-title';

    return (
      <div className="uitk-flex uitk-flex-justify-content-space-between uitk-flex-align-items-center all-b-padding-three">
        <Viewport>
          <ViewSmall>
            <h2 className={`${headerTitleClass} uitk-type-heading-600`} data-stid={dataStid}>
              {headerTitle}
            </h2>
          </ViewSmall>
          <ViewLarge>
            <h2 className={`${headerTitleClass} uitk-type-display-700`} data-stid={dataStid}>
              {headerTitle}
            </h2>
          </ViewLarge>
        </Viewport>
        {RightComponent}
      </div>
    );
  }
);
